import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLoader } from 'src/contexts/LoaderContext';

export default function OpenRoute() {
  const { hideLoader } = useLoader();
  useEffect(() => {
    hideLoader();
  }, [hideLoader]);
  return <Outlet />;
}
